import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { ReceiptVoucherImportFileHelperContainerModel } from '../../../../../../models/aggregates/generic_doc/receipt-voucher-import-file-helper-container.model';

@Injectable({
    providedIn: 'root'
})
export class ReceiptVoucherFileHelperService extends BaseApiTemplateService<ReceiptVoucherImportFileHelperContainerModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-receipt-voucher-import-file-helpers/backoffice-ep'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-receipt-voucher-import-file-helpers/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-receipt-voucher-import-file-helpers/backoffice-ep';
        this.httpClient = http;
    }

}

